import(/* webpackMode: "eager" */ "/codebuild/output/src828441159/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/bettor/bettor-display.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/bettor/crown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/bettor/leaderboard/animated-header-graphic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/bettor/leaderboard/container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/primitives/icon.tsx");
